namespace $.$$ {

	const Size_label = {
		justify: {
			content: 'center',
		},
		align: {
			items: 'center',
		},
		width: '30px'
	} as const

	const Section = {
		gap: $mol_gap.space,
		flex: {
			direction: 'column',
		},
	} as const

	const Delimiter_top = {
		padding: {
			top: $mol_gap.block,
		},
		margin: {
			top: $mol_gap.block,
		},
		borderTop: '1px solid var(--mol_theme_line)',
	} as const
	
	const Delimiter_bottom = {
		padding: {
			bottom: $mol_gap.block,
		},
		margin: {
			bottom: $mol_gap.block,
		},
		borderBottom: '1px solid var(--mol_theme_line)',
	} as const
	

	$mol_style_define( $shm_hitalama_map_widget_page, {
		Heading: { flex: { direction: 'column', grow: 1 }, minWidth: 0 },
		Heading_tabs: { width: '100%', align: { items: 'center' } },
		Z_jump: { flex: { wrap: 'wrap' } },
		Tabs: { flex: { wrap: 'wrap', grow: 1 } },
		Widget_type: {
			flex: { shrink: 0 },
			margin: { left: 'auto' },
		},
		Widget_type_icon: {
			width: '24px',
			height: '24px',
		},
		Text_scroll: { maxHeight: '30rem' },
		Text_labeler: { ...Delimiter_bottom, Label: { align: { items: 'center' } } },
		Text_copy: { margin: '-1rem' },
		
		width: '18rem',
		flex: {
			grow: 0,
		},

		Body_content: {
			padding: $mol_gap.space,
		},

		X: {
			String: {
				width: '4.5rem'
			},
		},
		Y: {
			String: {
				width: '4.5rem'
			},
		},
		Width: {
			String: {
				width: '4.5rem'
			},
		},
		Height: {
			String: {
				width: '4.5rem'
			},
		},
		Z: {
			String: {
				width: '4.5rem'
			},
		},
		Auto_height: {
			margin: {
				left: 'auto',
			},
		},

		Background_section: {
			gap: $mol_gap.space,
			align: {
				items: 'center',
			},
		},
		Background_labeler: {
			flex: {
				grow: 1,
			},
		},
		Background_hex: {
			String: {
				width: '7rem',
			},
		},
		Background_opacity_wrap: {
			position: 'relative',
			flex: {
				grow: 0,
			},
			'::after': {
				content: '"%"',
				position: 'absolute',
				right: '8px',
				top: '50%',
				transform: 'translateY(-50%)',
				pointerEvents: 'none',
				color: $mol_theme.shade,
				zIndex: 1,
			},
		},
		Background_opacity: {
			String: {
				width: '4rem',
				padding: {
					right: '1.5rem',
				},
			},
		},
		Border_section: {
			...Delimiter_bottom,
			gap: $mol_gap.space,
			align: {
				items: 'center',
			},
		},
		Border_labeler: {
			flex: {
				grow: 1,
			},
		},
		Border_hex: {
			String: {
				width: '7rem',
			},
		},
		Border_width: {
			flex: {
				grow: 0,
			},
		},
		Border_style: {
			flex: {
				grow: 0,
			},
			minWidth: '4rem',
			Trigger: {
				justify: {
					content: 'center',
				},
			},
			Option_row: {
				justify: {
					content: 'center',
				},
			},
		},
		Border_style_current: {
			width: '2.5rem',
			height: '1.5rem',
			align: {
				items: 'center',
			},
		},
		Border_style_current_line: {
			width: '100%',
			border: {
				bottom: {
					width: '3px',
					color: $mol_theme.text,
				},
			},
		},
		Border_style_current_none: {
			width: '1.25rem',
			height: '1.25rem',
			color: '#d33',
		},
		Border_style_option: {
			width: '6rem',
			height: '1.5rem',
			align: {
				items: 'center',
			},
		},
		Border_style_option_line: {
			width: '100%',
			border: {
				bottom: {
					width: '3px',
					color: $mol_theme.text,
				},
			},
		},
		Border_style_none: {
			width: '1.25rem',
			height: '1.25rem',
			color: '#d33',
		},
		Border_opacity_wrap: {
			position: 'relative',
			flex: {
				grow: 0,
			},
			'::after': {
				content: '"%"',
				position: 'absolute',
				right: '8px',
				top: '50%',
				transform: 'translateY(-50%)',
				pointerEvents: 'none',
				color: $mol_theme.shade,
				zIndex: 1,
			},
		},
		Border_opacity: {
			String: {
				width: '4rem',
				padding: {
					right: '1.5rem',
				},
			},
		},
		Font_section: {
			padding: {
				top: $mol_gap.block,
			},
			gap: $mol_gap.space,
			flex: {
				direction: 'column',
			},
		},
		Font_color_labeler: {
			flex: {
				grow: 1,
			},
			Content: {
				padding: {
					bottom: 0,
				},
			},
		},
		Font_color_hex: {
			String: {
				width: '7rem',
			},
		},
		Font_row: {
			gap: $mol_gap.space,
			align: {
				items: 'flex-start',
			},
		},
		Font_size_labeler: {
			flex: {
				grow: 0,
			},
			Label: {
				padding: {
					right: 0,
				},
			},
			Content: {
				padding: {
					right: 0,
				},
			},
		},
		Font_size: {
			flex: {
				grow: 0,
			},
		},
		Font_family_labeler: {
			flex: {
				grow: 1,
			},
			Label: {
				padding: {
					left: 0,
				},
			},
			Content: {
				padding: {
					left: 0,
				},
			},
		},
		Font_family: {
			String: {
				width: '100%',
			},
		},


		Type_settings: {
			...Delimiter_top,
		},
		
		X_label: Size_label,
		Y_label: Size_label,
		Width_label: {
			margin: {
				left: 'auto',
			},
			...Size_label,
		},
		Height_label: {
			margin: {
				left: 'auto',
			},
			...Size_label,
		},
		Z_label: Size_label,

		Size_section: {
			...Section,
			borderBottom: '1px solid var(--mol_theme_line)',
			padding: {
				left: $mol_gap.block,
				right: $mol_gap.block,
				bottom: $mol_gap.block,
			},
		},

		Tool_icons: {
			padding: {
				bottom: $mol_gap.space,
			},
		},


		Data_section: {
			...Delimiter_bottom,
			gap: $mol_gap.space,
			flex: {
				direction: 'column',
			},
		},
		Data_title: {
			// font: {
			// 	weight: 'bold',
			// },
			padding: {
				left: $mol_gap.block,
			},
		},
		Data_list: {
			gap: $mol_gap.space,
		},
		Data_labeler: {
			Content: {
				padding: {
					top: 0,
				},
			},
		},
		Data_value: {
			maxHeight: '18rem',
		},

		Hide_head_tools: Delimiter_top,

		Tools: {
			Delete: {
				margin: {
					left: 'auto',
				},
			},
		},
		
	} )
	
}
